import { render, staticRenderFns } from "./ArchiveLayers.vue?vue&type=template&id=1f9bcaae"
import script from "./ArchiveLayers.vue?vue&type=script&lang=js"
export * from "./ArchiveLayers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports